import { render, staticRenderFns } from "./EditSamlSetting.vue?vue&type=template&id=4486d426&scoped=true"
import script from "./EditSamlSetting.vue?vue&type=script&lang=js"
export * from "./EditSamlSetting.vue?vue&type=script&lang=js"
import style0 from "./EditSamlSetting.vue?vue&type=style&index=0&id=4486d426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4486d426",
  null
  
)

export default component.exports